// IONIX brand palette. The single source of truth for every colour in the
// app. Do not introduce off-palette hexes anywhere else; the entire game
// re-skins by editing only this file.
//
// Personality: Optimistic, Explorer, In control, Confident.
// Visual: Bright, Innovative, Focused, Calm. The calm counterweight to FUD
// security branding, so backgrounds lean light and accents are warm.

export const brand = {
  // Surfaces — IONIX leads on light backgrounds, Dark Blue is the depth.
  bg: '#F5F8FF',          // Background Light Blue
  bgPanel: '#FFFFFF',     // White (HUD card)
  bgDeep: '#0E204F',      // Dark Blue (used for boss-phase deep panels, end card)

  // Workhorse pair
  primary: '#5886FB',     // IONIX Main Blue (leading colour)
  primaryAlt: '#92B0FF',  // Lighter Blue (highlight / strokes)
  primarySoft: '#D9E4FF', // Light Blue 2 (filled supporting blocks)

  // Accent (warm) — used sparingly per brand: never dominant.
  asset: '#FFD386',       // Dark Yellow (loot / found-asset glow)
  assetSoft: '#FFEED0',   // Light Yellow (asset bloom backgrounds)
  warn: '#FF825B',        // Orange (caution states)
  threat: '#FF5A5A',      // Red (CVEs / danger, sparingly)

  // Mission-status colour. IONIX has no green; "patched / OK" reads as
  // the IONIX Main Blue so the success state stays on-brand.
  ok: '#5886FB',

  // Type
  text: '#0E204F',        // Dark Blue, body on light backgrounds
  textOnDark: '#FFFFFF',  // White, body on Main Blue / Dark Blue
  textDim: '#92B0FF',     // Lighter Blue, muted labels on light surfaces
  textDimOnDark: '#D9E4FF', // Light Blue 2, muted labels on Dark Blue
} as const;

export type BrandKey = keyof typeof brand;

const toInt = (hex: string): number => parseInt(hex.replace('#', ''), 16);

// Phaser wants 0xRRGGBB ints for tints/fills.
export const brandHex: Record<BrandKey, number> = {
  bg: toInt(brand.bg),
  bgPanel: toInt(brand.bgPanel),
  bgDeep: toInt(brand.bgDeep),
  primary: toInt(brand.primary),
  primaryAlt: toInt(brand.primaryAlt),
  primarySoft: toInt(brand.primarySoft),
  asset: toInt(brand.asset),
  assetSoft: toInt(brand.assetSoft),
  warn: toInt(brand.warn),
  threat: toInt(brand.threat),
  ok: toInt(brand.ok),
  text: toInt(brand.text),
  textOnDark: 0xffffff,
  textDim: toInt(brand.textDim),
  textDimOnDark: toInt(brand.textDimOnDark),
};
